import React from "react";

import { Typography, Divider, Stack, Box, Spacer } from "digiwash-components";
import { formatPrice } from "../../helpers/number";

import { formatNumber } from "digiwash-core";
import { LegacyInvoiceType } from "../../types/server";
import InvoiceRowNew from "./InvoiceRowNew-component";
import CustomIcon from "../../components/CustomIcon";

interface PropTypes {
  invoice?: LegacyInvoiceType;
  bg: string;
  featured?: boolean;
  walletAmount: number;
}

function BasketInvoiceNew(props: PropTypes) {
  if (!props.invoice) {
    return null;
  }
  let price = formatPrice(props.invoice.total_items_amount);
  let logistic = formatPrice(props.invoice.logistic_price);
  let discount = formatPrice(props.invoice.discount);
  let cash_back = formatPrice(props.invoice.cash_back);
  let vat = formatPrice(props.invoice.vat);
  let total_extra_charge = formatPrice(props.invoice.total_extra_charge);
  let total_price = formatPrice(props.invoice.total_price);
  let paymentAmount =
    props.invoice.total_price > Number(props.walletAmount)
      ? formatPrice(props.invoice.total_price - props.walletAmount)
      : `${formatNumber(0)}`;

  return (
    <>
      <Box bg={props.bg}>
        <Box px="l">
          <InvoiceRowNew name="مجموع خدمات" value={`${price} تومان`} />
          <Divider size="l" />
          <InvoiceRowNew name="مالیات بر ارزش‌افزوده" value={`${vat} تومان`} />
          <Divider size="l" />
          <InvoiceRowNew name="تخفیف" value={`${discount} تومان`} />

          {props.invoice.cash_back > 0 && (
            <>
              <Divider size="l" />
              <InvoiceRowNew name="هدیه" value={`${cash_back} تومان`} />
            </>
          )}

          {props.invoice.total_extra_charge > 0 && (
            <>
              <Divider size="l" />
              <InvoiceRowNew
                name="هزینه اضافی"
                value={`${total_extra_charge} تومان`}
              />
            </>
          )}
          <Divider size="l" />
          <InvoiceRowNew name="هزینه ارسال" value={`${logistic} تومان`} />
          {props.featured ? (
            <>
              <Divider size="l" />
              <InvoiceRowNew
                name="خدمات ویژه"
                value={`${logistic} تومان`}
                icon="featured"
              />
            </>
          ) : null}
        </Box>
      </Box>

      <Divider size="m" />
      <Stack px="l" distribution="start">
        <CustomIcon icon="warningGreen" width={16} height={16} />
        <Spacer size="s" />
        <Typography color="green.main" fs="s" ff="mainBold">
          هزینه حمل و نقل برای سفارش های بالای {formatNumber(600)} هزار تومان
          رایگان است.
        </Typography>
      </Stack>
      <Divider size="xm" />
      <Divider line="gray.light" />
      <Divider size="xm" />
      <Box px="l">
        <Stack distribution="space-between">
          <Typography ff="mainBold" color="common.black">
            قابل پرداخت
          </Typography>
          <Typography ff="mainBold" color="common.black" fs="l">
            {paymentAmount} تومان
          </Typography>
        </Stack>
      </Box>
      <Box br="xm" px="l">
        <Divider size="l" />
        {props.walletAmount === 0 ? null : (
          <>
            <Stack distribution="space-between">
              <Typography color="gray.light950">کیف پول</Typography>
              <Typography color="gray.light950" fs="xm">
                {formatPrice(props.walletAmount)} تومان
              </Typography>
            </Stack>
            <Divider size="l" />
            <Stack distribution="space-between">
              <Typography color="gray.light950">جمع کل سفارش</Typography>
              <Typography color="gray.light950" fs="xm">
                {total_price} تومان
              </Typography>
            </Stack>
          </>
        )}
      </Box>
    </>
  );
}

export default BasketInvoiceNew;
